import React from 'react';
import { Form, Input, DatePicker, Divider } from 'antd';
import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/ru_RU';

const startDateDoc = value => {
  return value.format('x') < moment().format('x') - 43000;
};

const TachographCards = ({ isEditable, form }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const tachographСards_skzi = getFieldValue('tachographСards_skzi');
  const tachographСards_estr = getFieldValue('tachographСards_estr');
  return (
    <div className="b-form-fields">
      {tachographСards_skzi && (
        <>
          <div className="b-form-fields__item">
            <Form.Item label="Карта водителя СКЗИ">
              {getFieldDecorator('tachographСards_skzi', {
                rules: [],
              })(
                <Input
                  style={{ width: 368 }}
                  placeholder="Укажите карту водителя СКЗИ"
                  disabled={!isEditable}
                />
              )}
            </Form.Item>
          </div>
          <div className="b-form-fields__item">
            <Form.Item label="Действительно до">
              {getFieldDecorator('tachographСardsEndDate_skzi', {
                rules: [],
              })(
                <DatePicker
                  style={{ width: 224 }}
                  placeholder="ДД.ММ.ГГГГ"
                  format={'DD.MM.YYYY'}
                  disabled={!isEditable}
                  disabledDate={startDateDoc}
                  locale={locale}
                />
              )}
            </Form.Item>
          </div>
        </>
      )}
      {tachographСards_estr && (
        <>
          <div className="b-form-fields__item">
            <Form.Item label="Карта водителя ЕСТР (евро)">
              {getFieldDecorator('tachographСards_estr', {
                rules: [],
              })(
                <Input
                  style={{ width: 368 }}
                  placeholder="Укажите карту водителя ЕСТР"
                  disabled={!isEditable}
                />
              )}
            </Form.Item>
          </div>
          <div className="b-form-fields__item">
            <Form.Item label="Действительно до">
              {getFieldDecorator('tachographСardsEndDate_estr', {
                rules: [],
              })(
                <DatePicker
                  style={{ width: 224 }}
                  placeholder="ДД.ММ.ГГГГ"
                  format={'DD.MM.YYYY'}
                  disabled={!isEditable}
                  disabledDate={startDateDoc}
                  locale={locale}
                />
              )}
            </Form.Item>
          </div>
        </>
      )}
      {tachographСards_estr ||
        (tachographСards_skzi && <Divider style={{ background: '#d9d9d9' }} />)}
    </div>
  );
};

export default TachographCards;
